import * as Status from '../../../constants/status';
import * as Role from '../../../constants/role';
import moment from 'moment';
import { isRoleAuditoriaNsir } from '../../../helpers/auditoriaNsirPermission';
import { getNsirFiltroFixoAuditoriaNsir, INSPECAO_USUO_MUTUO_ID, mergeFiltroNsirComRestricoesAuditoria } from '../../../utils';

export const DEFAULT_DATE_TYPES = [
  'DATA_CRIACAO',
  'DATA_DIGITACAO',
  'DATA_EXECUTADA_GDIS',
  'DATA_INSPECAO',
  'DATA_VENCIMENTO',
];

export const DEFAULT_STATUS = [
  Status.AGUARDANDO_INSPECAO,
  Status.EM_INSPECAO,
  Status.INSPECAO_FINALIZADA,
  Status.INSPECAO_ENVIADA_PARCIAL,
  Status.AGUARDANDO_DIGITACAO,
  Status.EM_DIGITACAO,
  Status.DIGITACAO_FINALIZADA,
];

export const formatPeriodLabel = (inicio, fim) => {
  if (inicio == null || fim == null) return '';
  return `${moment(inicio).format('DD/MM/YYYY')} – ${moment(fim).format('DD/MM/YYYY')}`;
};

export const getDefaultFilter = (authDataEmail, isUsuarioUsoMutoFn, userRole, authDataId) => {
  const base = {
    inicio: moment().subtract(1, 'year').startOf('year').valueOf(),
    fim: moment().endOf('day').valueOf(),
    status: DEFAULT_STATUS,
    dateTypes: DEFAULT_DATE_TYPES,
    tipoServicos: isUsuarioUsoMutoFn(authDataEmail) ? [INSPECAO_USUO_MUTUO_ID] : null,
  };

  if (userRole === Role.DIGITADOR && authDataId) {
    base.digitadorIds = [authDataId];
  }

  if (isRoleAuditoriaNsir(userRole)) {
    return { ...base, ...getNsirFiltroFixoAuditoriaNsir() };
  }
  return base;
};

export const resolveNsirLocalFilter = (cacheFiltroNsir, defaultFilter, isAuditor) => {
  if (cacheFiltroNsir && Object.keys(cacheFiltroNsir).length > 0) {
    return isAuditor
      ? mergeFiltroNsirComRestricoesAuditoria(cacheFiltroNsir)
      : cacheFiltroNsir;
  }
  return defaultFilter;
};

export const getDefaultStatusParaFiltroNsirs = userRole =>
  (isRoleAuditoriaNsir(userRole) ? getNsirFiltroFixoAuditoriaNsir().status : DEFAULT_STATUS);

export const getStatusOptionsByRole = (userRole) => {
  if (isRoleAuditoriaNsir(userRole)) {
    return [
      { id: Status.DIGITACAO_FINALIZADA, nome: 'Digitação Finalizada' },
      { id: Status.EXECUTADA_GDIS, nome: 'Executada GDIS' },
    ];
  }

  if (userRole === Role.INSPETOR) {
    return [
      { id: Status.AGUARDANDO_INSPECAO, nome: 'Aguardando Inspeção' },
      { id: Status.EM_ANALISE, nome: 'Em Análise' },
      { id: Status.INSPECAO_EM_ENVIO, nome: 'Inspeção em Envio' },
      { id: Status.EM_INSPECAO, nome: 'Em Inspeção' },
      { id: Status.INSPECAO_ENVIADA_PARCIAL, nome: 'Inspeção Enviada Parcial' },
      { id: Status.INSPECAO_SYNC_ERROR, nome: 'Inspeção com Erro de Envio' },
      { id: Status.ERRO_AO_ENVIAR_INSPECAO, nome: 'Erro ao enviar Inspeção' },
      { id: Status.INSPECAO_FINALIZADA, nome: 'Inspeção Finalizada' },
      { id: Status.AGUARDANDO_DIGITACAO, nome: 'Aguardando Digitação' },
      { id: Status.EM_DIGITACAO, nome: 'Em Digitação' },
      { id: Status.DIGITACAO_FINALIZADA, nome: 'Digitação Finalizada' },
      { id: Status.EXECUTADA_GDIS, nome: 'Executada GDIS' },
    ];
  }

  if (userRole === Role.DIGITADOR) {
    return [
      { id: Status.INSPECAO_FINALIZADA, nome: 'Inspeção Finalizada' },
      { id: Status.EM_ANALISE, nome: 'Em Análise' },
      { id: Status.AGUARDANDO_DIGITACAO, nome: 'Aguardando Digitação' },
      { id: Status.EM_DIGITACAO, nome: 'Em Digitação' },
      { id: Status.DIGITACAO_FINALIZADA, nome: 'Digitação Finalizada' },
      { id: Status.EXECUTADA_GDIS, nome: 'Executada GDIS' },
    ];
  }

  return [
    { id: Status.EM_CRIACAO, nome: 'Em Criação' },
    { id: Status.EM_ANALISE, nome: 'Em Análise' },
    { id: Status.AGUARDANDO_INSPECAO, nome: 'Aguardando Inspeção' },
    { id: Status.INSPECAO_EM_ENVIO, nome: 'Inspeção em Envio' },
    { id: Status.EM_INSPECAO, nome: 'Em Inspeção' },
    { id: Status.INSPECAO_ENVIADA_PARCIAL, nome: 'Inspeção Enviada Parcial' },
    { id: Status.INSPECAO_SYNC_ERROR, nome: 'Inspeção com Erro de Envio' },
    { id: Status.ERRO_AO_ENVIAR_INSPECAO, nome: 'Erro ao enviar Inspeção' },
    { id: Status.INSPECAO_FINALIZADA, nome: 'Inspeção Finalizada' },
    { id: Status.AGUARDANDO_DIGITACAO, nome: 'Aguardando Digitação' },
    { id: Status.EM_DIGITACAO, nome: 'Em Digitação' },
    { id: Status.DIGITACAO_FINALIZADA, nome: 'Digitação Finalizada' },
    { id: Status.EXECUTADA_GDIS, nome: 'Executada GDIS' },
  ];
};

export const DIALOG_TYPES = {
  IMPORT: 'import',
  IMPORT_NSMPS: 'importNsmps',
  IMPORT_FINANCEIRO: 'importFinanceiro',
  IMPORT_DIGITADOR: 'importDigitador',
  EXPORT: 'export',
  EXPORT_EDIT: 'exportEdit',
  EXPORT_SERVICO: 'exportServico',
  EXPORT_FINANCEIRO: 'exportFinanceiro',
  EXPORT_DIGITADOR: 'exportDigitador',
  EXPORT_INSPECAO: 'exportInspecao',
  EXPORT_REPORT_USO_MUTUO: 'exportReportUsoMutuo',
  EXPORT_DIGITADOR_DIARIO: 'exportDigitadorDiario',
  EXPORT_PROJETO_OBRAS: 'exportProjetoObras',
  IMPORT_PREVIEW: 'importPreview',
};

export const ERROR_MESSAGES = {
  INVALID_SHEET: "Planilha inválida. Por favor, utilize a planilha 'Planilha Importação' que se encontra na aba de Documentos!",
  INVALID_FILE: "Arquivo inválido. Por favor, utilize um arquivo válido para importar os serviços!",
  INVALID_DIGITADOR_SHEET: "Planilha inválida. Por favor, exporte a planilha de digitadores e utilize-a!",
  READ_ERROR: 'Erro ao abrir a planilha. Por favor, tente novamente!',
};

export const EXPORT_MESSAGES = {
  NSIRS: 'Deseja exportar todas as NSIRs filtradas?',
  EDIT: 'Deseja exportar todas as NSIRs filtradas para edição?',
  SERVICO: 'Deseja exportar todos os serviços para as NSIRs filtradas?',
  INSPECAO: 'Deseja exportar as informações da inspeção para as NSIRs filtradas?',
  FINANCEIRO: 'Selecione o formato e confirme a exportação das NSIRs filtradas para financeiro.',
  DIGITADOR: 'Deseja exportar todas as NSIRs filtradas para digitadores?',
  USO_MUTUO: 'Deseja exportar todas as NSIRs filtradas para Uso Mútuo?',
  DIGITADOR_DIARIO: 'Deseja exportar o relatório de digitadores diários para os últimos 7 dias?',
  PROJETO_OBRAS: 'Deseja exportar o relatório de Projeto e Obras para as NSIRs filtradas?',
};

export const EXPORT_FINANCEIRO_FORMAT = {
  SINGLE_TAB: false,
  SPLIT_BY_INSPETOR: true,
};

export const EXPORT_FINANCEIRO_FORMAT_LABELS = {
  [false]: 'Todas NSIRs em uma única aba',
  [true]: 'Resumo e abas por inspetor',
};

export const DIGITADOR_DIARIO_ALLOWED_EMAILS = [
  'vinicius_admin',
  'NUBIA CRISTINA RIGUEIRA SALGADO',
  'RAFAEL DIAS GARCIA',
];

const toArray = (v) => (Array.isArray(v) ? v : [v]);

export const normalizeNsirFilterForApi = (filter) => {
  if (!filter || typeof filter !== 'object') return {};

  const { inspetorId, digitadorId, inspetorIds, digitadorIds, ...rest } = filter;
  const body = { ...rest };

  if (Array.isArray(inspetorIds) && inspetorIds.length > 0) {
    body.inspetorIds = inspetorIds;
  } else if (inspetorId != null && inspetorId !== '') {
    body.inspetorIds = toArray(inspetorId);
  }

  if (Array.isArray(digitadorIds) && digitadorIds.length > 0) {
    body.digitadorIds = digitadorIds;
  } else if (digitadorId != null && digitadorId !== '') {
    body.digitadorIds = toArray(digitadorId);
  }

  if (filter.vencimentoUrgency) {
    body.vencimentoUrgency = filter.vencimentoUrgency;
  }

  return body;
};
